import { render } from "./Panel.vue?vue&type=template&id=3912e8f0&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=3912e8f0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src192932826/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3912e8f0"]])

export default __exports__